export const createErrorMessage = (element, validate) => {
  const errorMessage = validate[element].$errors.length
    ? validate[element].$errors[0].$message
    : "";
  return errorMessage
}
